/**
 * Module Types and Utilities
 * Frontend module definitions and helpers
 */

/**
 * Get module display name from module key
 */
export function getModuleDisplayName(moduleKey: string): string {
  const moduleNames: Record<string, string> = {
    playground: 'Playground',
    'activity.chatLogs': 'Activity - Chat Logs',
    'activity.leads': 'Activity - Leads',
    'activity.media': 'Activity - Inbound Media',
    'analytics.chats': 'Analytics - Chats',
    'analytics.topics': 'Analytics - Topics',
    'analytics.sentiment': 'Analytics - Sentiment',
    'sources.files': 'Sources - Files',
    'sources.text': 'Sources - Text',
    'sources.website': 'Sources - Website',
    'sources.qa': 'Sources - Q&A',
    'sources.notion': 'Sources - Notion',
    'sources.suggestions': 'Sources - Suggestions',
    'sources.media': 'Media Library',
    reports: 'Reports (CSV Export)',
    actions: 'Actions',
    agents: 'Agents',
    contacts: 'Contacts',
    deploy: 'Deploy',
    userManagement: 'User Management',
    settings: 'Settings',
    campaigns: 'Campaigns',
    systemAlerts: 'System Alerts',
  };

  return moduleNames[moduleKey] || moduleKey;
}
